import {
  IAnnouncement,
  IAnnouncementsPage
} from '@shared/interfaces/announcement.interface';

export class Announcement {
  public static fromAPI(raw: { id: string; attributes: any }): IAnnouncement {
    return { id: raw.id, ...raw.attributes };
  }

  public static pageFromAPI(res: any): IAnnouncementsPage {
    return {
      items: (res.data || []).map(Announcement.fromAPI),
      meta: res.meta || { current_page: 1, total_pages: 1, total_entries: 0 }
    };
  }
}
